import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import SignatoriesAndShareholdersPage from './SignatoriesAndShareholdersPage';
import { dataCaptureSelectors, saveSignatoriesAndShareholdersForm } from '../../store/dataCapture';
import { SIGNATORIES_SHAREHOLDER_DATA, PRIMARY_APPLICANT } from '../../utils/constants';
import { officerSelector } from '../../infrastructure/officer';
import {
  generateApplicant,
  getControlBusinessValues
} from '../../infrastructure/officer/payloadUtils/mapOfiicerDetails';

const SignatoriesAndShareholdersSection = ({
  saveSignatoriesAndShareholdersForm,
  getBusinessData,
  primaryApplicant
}) => {
  return (
    <SignatoriesAndShareholdersPage
      saveSignatoriesAndShareholdersForm={values => {
        saveSignatoriesAndShareholdersForm(values, generateApplicant(values, primaryApplicant));
      }}
      getBusinessData={
        !getBusinessData && !primaryApplicant.officer_id
          ? ''
          : getControlBusinessValues(getBusinessData, primaryApplicant)
      }
      showSubmit
    />
  );
};

SignatoriesAndShareholdersSection.propTypes = {
  saveSignatoriesAndShareholdersForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveSignatoriesAndShareholdersForm
};

const mapStateToProps = state => ({
  getBusinessData: dataCaptureSelectors.getBusinessData(state, SIGNATORIES_SHAREHOLDER_DATA),
  primaryApplicant: officerSelector.getBusinessData(state, PRIMARY_APPLICANT)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SignatoriesAndShareholdersSection);
